import { render, staticRenderFns } from "./resendlog.vue?vue&type=template&id=0de046ba&scoped=true&"
import script from "./resendlog.vue?vue&type=script&lang=js&"
export * from "./resendlog.vue?vue&type=script&lang=js&"
import style0 from "./resendlog.vue?vue&type=style&index=0&id=0de046ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de046ba",
  null
  
)

export default component.exports